<template>
  <div class="display-flex" style="height: calc(100vh - 150px)">
    <div class="left">
      <div class="display-flex ai-center jc-space-between mb-20">
        <b class="fs-18">目标文件目录</b>
      </div>
      <div class="list scrollbar-y" style="height: calc(100vh - 250px)">
        <el-scrollbar>
            <div
                class="item"
                :class="{active: selectedId && item.id === selectedId}"
                v-for="item in catalogueList"
                @click="clickRow(item)"
                :key="item.id">
                <span class="text-ellipsis fs-14 mr-10 mb-18"> {{item.filename}}</span>
                <span class="text-ellipsis fs-12 mr-10 color-info"> <i class="el-icon-location-outline"></i> {{item.dstDir}}</span>
            </div>
            <el-empty :image-size="100"  v-if="!catalogueList.length" description="暂无数据"></el-empty>
        </el-scrollbar>
      </div>
    </div>
    <div class="right">
      <span class="fs-18 mb-20" style="display: block">当前:{{selectedName}}</span>
      <div class="display-flex jc-space-between ai-center mb-20">
        <div class="display-flex ai-center">
          <el-input class="width-230" placeholder="名称搜索" size="small" v-model="fileSearchForm.fuzzy"></el-input>
          <el-button type="primary" @click="getFileList" size="small" class="ml-16"> 查询</el-button>
          <el-button type="primary" @click="fileSearchForm.fuzzy=''" size="small">重置</el-button>
        </div>
        <el-button type="primary" size="small" @click="add">新增</el-button>
      </div>
      <el-table :data="selFileList" border  >
        <el-table-column
          show-overflow-tooltip
          prop="filename"
          label="文件模板名称">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="remark"
          label="文件模板描述">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createByName"
          label="创建人">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="updateByName"
          label="最后修改人">
         <template #default="{row}">
          {{row.updateByName||'--'}}
         </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="updateAt"
          label="最后修改时间">
          <template #default="{row}">
            {{row.updateAt||'--'}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="300px"
          label="操作">
          <template #default="{row}">
            <el-button @click="show(row.id)" type="text" class="color-primary">查看</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="edit(row.id)" type="text" class="color-primary">编辑</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="copy(row.id)" type="text" class="color-primary">复制</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="del(row.id)" type="text" class="color-danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="display-flex fd-row-reverse mt-20">
        <el-pagination
          @current-change="(val) => {fileSearchForm.pageNum = val}"
          :current-page="fileSearchForm.pageNum"
          :page-size="fileSearchForm.pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      v-if="dialog.show"
      :title="dialog.title"
      :visible.sync="dialog.show"
      ref="dialogForm"
      width="1000px"
      top="6vh">
      <div class="padding-20">
        <span>目标文件名称：{{selectedName}}</span>
        <el-form
          :model="dialog.form"
           ref="ruleForm"
           label-width="120px"
           class="mt-20 no-mb-formItem"
           label-position="top">
          <el-form-item label="文件模板名称:" prop="name" :rules="{required: true, message: '请输入名称', trigger: 'blur'}">
            <span v-if="showStatus">{{dialog.form.name}}</span>
            <el-input v-else v-model="dialog.form.name" class="width-percent-50"></el-input>
          </el-form-item>
          <el-form-item label="文件模板描述:" prop="message">
            <span v-if="showStatus">{{dialog.form.message}}</span>
            <el-input  v-else v-model="dialog.form.message" class="width-percent-50" type="textarea" :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="文件模板内容:">
            <wang-editor  class="mt-10" ref="editor" :default-html="html"  :show-toolbar="showToolbar"></wang-editor>
          </el-form-item>
        </el-form>
      </div>
      <template #footer v-if="!showStatus">
        <el-button @click="dialog.show = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading" >确认</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import wangEditor from '@/components/WangEditor';
import _ from 'lodash';
export default {
  name: 'Index',
  components: { wangEditor },
  props: {},
  data () {
    return {
      total: 0,
      showToolbar: true,
      showStatus: false,
      editorObj: null,
      html: '',
      editor: null,
      loading: false,
      dialog: {
        title: '',
        show: false,
        form: {
          id: '',
          message: '',
          name: ''
        }
      },
      selectedName: '',
      selectedId: '',
      catalogueSearchForm: {
        pageNum: 1,
        pageSize: 10,
        fuzzy: ''
      },
      fileSearchForm: {
        pageNum: 1,
        pageSize: 10,
        fuzzy: ''
      },
      catalogueList: [],
      selFileList: []
    }
  },
  filters: {},
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        console.log(newVal, oldVal)
        if (newVal.pageNum !== 1 && newVal.pageNum === oldVal.pageNum) {
          this.fileSearchForm.pageNum = 1;
        } else {
          this.getFileList()
        }
      },
      deep: true
    }
  },
  computed: {
    /**
     * 监听复杂数据类型的变换
     */
    _searchForm () {
      return JSON.parse(JSON.stringify(this.fileSearchForm))
    }
  },
  methods: {
    clickRow (row) {
      console.log(row)
      this.selectedId = row.id
      this.selectedName = row.filename
      this.getFileList()
    },
    // noMask () {
    //   this.disabled = false
    //   this.showStatus = false
    // },
    add () {
      this.dialog.show = true
      this.showStatus = false
      this.showToolbar = true
      this.dialog.title = '新增模板'
      this.html = ''
      this.dialog.form = {
        id: '',
        message: '',
        name: ''
      }
    },
    edit (id) {
      this.getInfo(id)
      this.showStatus = false
      this.showToolbar = true
      this.dialog.title = '编辑模板'
      this.dialog.show = true
    },
    getInfo (id) {
      return new Promise(resolve => {
        this.$api.template.getFileInfo({ id }).then(res => {
          console.log(res)
          if (this.$refs.editor) {
            this.$refs.editor.editor.setHtml(res.content)
          }
          this.dialog.form = {
            message: res.remark,
            name: res.filename,
            id: id
          }
          resolve(res)
        })
      })
    },
    show (id) {
      this.showStatus = true
      this.showToolbar = false
      this.dialog.title = '查看模板'
      this.getInfo(id)
      this.dialog.show = true
    },
    del (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.template.delFile([id]).then(res => {
          this.$message.success('删除成功')
          this.getFileList()
        })
      }).catch(() => {
      });
    },
    copy (id) {
      this.getInfo(id).then((infoData) => {
        console.log(infoData)
        const data = {
          content: infoData.content,
          docTemplateId: infoData.docTemplateId,
          filename: infoData.filename,
          remark: infoData.remark
        }
        this.$api.template.addFile(data).then(res => {
          console.log(res)
          this.$message.success('复制成功')
          this.getFileList()
        })
      })
    },
    getFileList: _.debounce(function () {
      const data = {
        docTemplateId: this.selectedId,
        fuzzy: this.fileSearchForm.fuzzy,
        pageNum: this.fileSearchForm.pageNum,
        pageSize: this.fileSearchForm.pageSize
      }
      this.$api.template.getFileList(data).then(res => {
        this.selFileList = res.list
        this.total = res.total
      })
    }, 500),
    /**
     * 提交表单
     * @param formName
     */
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const data = {
            content: this.$refs.editor.editor.getHtml(),
            docTemplateId: this.selectedId,
            filename: this.dialog.form.name,
            remark: this.dialog.form.message
          }
          if (this.dialog.form.id) {
            data.id = this.dialog.form.id
            this.$api.template.editFile(data).then(res => {
              this.dialog.show = false
              this.$message.success('编辑成功')
              this.$refs.ruleForm.resetFields();
              this.getFileList()
            })
          } else {
            this.$api.template.addFile(data).then(res => {
              this.dialog.show = false
              this.$message.success('添加成功')
              this.$refs.ruleForm.resetFields();
              this.getFileList()
            })
          }
        }
      })
    },
    getCatalogueList () {
      return new Promise((resolve, reject) => {
        this.$api.template.getCatalogueList(this.catalogueSearchForm).then(res => {
          this.catalogueList = res.list
          this.selectedId = res.list[0].id
          this.selectedName = res.list[0].filename
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.getCatalogueList().then(() => { this.getFileList() })
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.left {
  width: 350px;
  padding: 20px;
  margin-right: 16px;
  background-color: white;
  .list {
    .item{
      padding: 16px;
      display: flex;
      flex-direction: column;
      margin-bottom: 14px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      cursor: pointer;
    }
    .active {
      border: 1px solid #328FFF;
      position: relative;
      &:before {
        text-align: right;
        font-size: 12px;
        padding: 2px;
        content: '√';
        position: absolute;
        right: 0;
        top: 0;
        width: 14px;
        height: 14px;
        background:#1774FF ;
        color: #ffffff;
        border-bottom-left-radius: 20px;
      }
    }
  }
}
.right{
  flex: 1;
  padding: 20px;
  overflow: hidden;
  background-color: #FFFFFF;
  .list{
    display: grid;
    grid-gap: 20px;
    padding: 10px;
    grid-template-columns: repeat(5, 1fr);
    .item {
      width: 334px;
      overflow: hidden;
      border: 1px solid #E6E6E6;
      padding: 20px;
      img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
      }
    }
  }
}
.no-mb-formItem{
  ::v-deep
  .el-form-item{
    margin-bottom: 4px;
    .el-form-item__label{
      padding: 0;
    }
  }

}
</style>
